import React from 'react';

const ThankYouModal = ({ close }) => {
    // Inline Style Objects
    const styles = {
        backdrop: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
        },
        card: {
            background: '#ffffff',
            padding: '40px 30px',
            borderRadius: '16px',
            maxWidth: '450px',
            width: '90%',
            textAlign: 'center',
            position: 'relative',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.25)',
            boxSizing: 'border-box',
        },
        closeCorner: {
            position: 'absolute',
            top: '12px',
            right: '20px',
            background: 'none',
            border: 'none',
            fontSize: '28px',
            color: '#999',
            cursor: 'pointer',
            lineHeight: 1,
        },
        iconWrap: {
            width: '70px',
            height: '70px',
            backgroundColor: '#f9f5eb', // Soft champagne background tint
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
        },
        checkmark: {
            fontSize: '32px',
        },
        headline: {
            fontSize: '28px',
            color: '#222222',
            margin: '0 0 12px 0',
            fontWeight: '600',
            fontFamily: 'sans-serif',
        },
        subtext: {
            fontSize: '15px',
            color: '#666666',
            lineHeight: '1.6',
            margin: '0 0 28px 0',
        },
        button: {
            background: 'linear-gradient(135deg, #d4af37 0%, #b89020 100%)', // Premium Gold Gradient
            color: '#ffffff',
            border: 'none',
            padding: '14px 32px',
            fontSize: '16px',
            fontWeight: '500',
            borderRadius: '30px',
            cursor: 'pointer',
            width: '100%',
            letterSpacing: '0.5px',
            boxShadow: '0 5px 15px rgba(212, 175, 55, 0.3)',
            transition: 'all 0.2s ease',
        }
    };

    return (
        <div style={styles.backdrop} onClick={close}>
            <div style={styles.card} onClick={(e) => e.stopPropagation()}>
                {/* Top right close button */}
                <button style={styles.closeCorner} onClick={close}>&times;</button>

                {/* Soft elegant icon badge */}
                <div style={styles.iconWrap}>
                    <span style={styles.checkmark}>✨</span>
                </div>

                <h2 style={styles.headline}>Thank You!</h2>
                <p style={styles.subtext}>
                    Your submission was successful. Our team will get back to you shortly to finalize your journey to confidence.
                </p>

                {/* Call to action button */}
                <button
                    onClick={close}
                    style={styles.button}
                    onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 8px 20px rgba(212, 175, 55, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 5px 15px rgba(212, 175, 55, 0.3)';
                    }}
                >
                    Back to Website
                </button>
            </div>
        </div>
    );
};

export default ThankYouModal;
